import { type CustomColumnDef } from '@ctn/ui/types/ctn-table';

import { type INotificacionesTransformadas } from '@/interfaces/model/emisor.interface';

export const columns: Array<CustomColumnDef<INotificacionesTransformadas>> = [
	{
		accessorKey: 'name',
		header: 'Servicios y notificaciones',
		responsive: {
			sizeColumn: 'full' 
		},
		td: { align: 'left' },
		th: { align: 'left' }
	},
	{
		accessorKey: '',
		header: 'Prioridad notificaciones',
		responsive: {
			sizeColumn: 'full'
		},
		td: { align: 'right' },
		th: { align: 'left', width: 154 }
	}
];